import React from 'react';
import styled from 'styled-components/macro';

const StyledSectionSub = styled.div`
  color: black;
  font-family: Lato;
  font-weight: 900;
  font-style: normal;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 2px;
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${props =>
    props.subTitleMarginBottom === 'default'
      ? '28px'
      : props.subTitleMarginBottom};
`;

const SectionSubTitle = props => {
  return (
    <StyledSectionSub subTitleMarginBottom={props.subTitleMarginBottom}>
      {props.sectionSubTitle}
    </StyledSectionSub>
  );
};

export default SectionSubTitle;
